var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"relative"},[_vm._t("default"),_vm._v(" "),(_vm.realcount !== _vm.localCount)?_c('div',{staticClass:"absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full animate-pulse -mr-2"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }